/**
 * @format
 * @flow
 */
// FIXME: 開発環境かどうか（/dev)
//const ApiDomain = 'http://localhost:3000';
let ApiDomain = 'https://api.taskell.jp';
if (process.env.REACT_APP_DIST_ENV === 'development' || process.env.NODE_ENV === 'staging') {
  ApiDomain += '/prd';
} else {
  ApiDomain += '/prd';
}
// sign
export const signUpApi = `${ApiDomain}/enterprise/signup`;
export const signInApi = `${ApiDomain}/enterprise/login`;
// task
export const getCurrentTaskApi = `${ApiDomain}/enterprise/myTasks`;
export const getOldTaskApi = `${ApiDomain}/enterprise/myTasks`;
export const getTaskDetailApi = `${ApiDomain}/enterprise/taskDetails`;
export const taskDeleteApi = `${ApiDomain}/enterprise/taskDetails`;
export const taskrewApprovalApi = `${ApiDomain}/enterprise/taskApproval`;
export const taskEditApi = `${ApiDomain}/enterprise/taskDetails`;
export const taskCreateApi = `${ApiDomain}/enterprise/stateAtTasks`;
export const taskReviewApi = `${ApiDomain}/enterprise/review`;
export const taskContractApi = `${ApiDomain}/enterprise/taskContract`;
// payment
export const getPaymentApi = `${ApiDomain}/enterprise/paymentReward`;

// setting
export const settingsApi = `${ApiDomain}/enterprise/mypage`;

// other
export const contactsApi = `${ApiDomain}/enterprise/contacts`;

export const getCategoriesApi = `${ApiDomain}/categories`;

export const getNotificationApi = `${ApiDomain}/enterprise/notification`;
export const postTemplateApi = `${ApiDomain}/enterprise/template`;

const AWSENDPOINT = 'taskell-prd';

export const AWSConfig = {
  region: 'ap-northeast-1',
  accessKeyId: 'AKIAIB7C6LWADZDLVJMA',
  secretAccessKey: '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',
  LICENSES_TABLE: `${AWSENDPOINT}-licenses`,
  TASKCATEGORY_TABLE: `${AWSENDPOINT}-taskCategories`,
  ENTERPRISECATEGORY_TABLE: `${AWSENDPOINT}-enterpriseCategories`,
  BANKS_TABLE: `${AWSENDPOINT}-banks`,
  BRANCHS_TABLE: `${AWSENDPOINT}-branchs`,
  QUESTION_TABLE: `${AWSENDPOINT}-question`,
  COUNTRY_TABLE: `${AWSENDPOINT}-country`
};
